import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSubRoutes, useExactRedirect, useAccessGuard } from 'hooks';
import { globalPropTypes, checkPermissions } from 'helpers';
import { Tabs, Alerts } from 'components';
import CisHeader from 'components/CisHeader/CisHeader';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.yc.meetings',
    url: '/yc/meetings',
  },
];

/**
 * The YC Assembly NDA is the one meeting of the Young Crew profile, and it is
 * kept from everybody but the officers holding its right. The route carries
 * that right itself, so for everybody else the navigation entry is not there at
 * all rather than leading to a refusal.
 */
const tabs = [
  {
    title: 'navigation.tabs.ipma.meetings.ycnda',
    path: '/yc/meetings/ycnda',
    key: 'ycnda',
    roles: ['yc_meeting_view_ycnda'],
  },
];

const Meetings = ({ routes, userPermissions }) => {
  const { t } = useTranslation();

  const [renderSubRoutes] = useSubRoutes(routes);

  // Permissions are loaded after the first render, so the redirect waits until
  // there is something to decide from.
  const permissionsKnown = !!userPermissions;
  const firstAllowedTab = permissionsKnown
    ? tabs.find((tab) => checkPermissions({ roles: tab.roles }, userPermissions))
    : null;

  const [renderExactRedirect] = useExactRedirect(
    '/yc/meetings',
    firstAllowedTab ? firstAllowedTab.path : null,
  );

  const [, renderAccessDeniedModal] = useAccessGuard(
    !permissionsKnown || !!firstAllowedTab,
    '/yc',
    'page.yc.meetings.accessDenied',
  );

  return (
    <>
      <CisHeader
        breadcrumbs={breadcrumbs}
        title={t('page.yc.meetings.title')}
        renderActions={() => <div id="yc-meetings-buttons-portal" />}
      />
      <Tabs disableCounter items={tabs} />
      <Alerts type="meetings" />
      {renderAccessDeniedModal()}
      {renderExactRedirect()}
      {renderSubRoutes()}
    </>
  );
};

Meetings.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  userPermissions: globalPropTypes.UserPermissions.isRequired,
};

Meetings.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ user }) => ({
  userPermissions: user.userPermissions,
});

export default connect(mapStateToProps, null)(Meetings);
